// eslint-disable class-methods-use-this
import { connect } from 'pwa-helpers/connect-mixin';
import { customElement } from 'lit/decorators.js';
import store from '@mfe/store';
import { CustomerAttribute } from '@mfec/customerAttributes/types';
import { TefComsCustomerAttributeBase } from '@mfec/customerAttributes/TefComsCustomerAttributeBase';
import { setCustomerAttribute } from '@mfe/store/consents';
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import { templates } from './templates'; // eslint-disable-line import/no-cycle

const CompositeClass = TemplatingMixin(connect(store)(TefComsCustomerAttributeBase), 'occl', templates);

@customElement('tef-coms-customer-attribute')
export class TefComsCustomerAttribute extends CompositeClass {
  connectedCallback() {
    super.connectedCallback();
    // Only available here after store init and not on top of the class :(
    this.setTemplatingTheme(this.theme);
  }

  get customerAttributes() {
    const { consents: { customerAttributes } } = store.getState();
    return customerAttributes;
  }

  get customerAttributesOrigin() {
    const { consents: { customerAttributesOrigin } } = store.getState();
    return customerAttributesOrigin;
  }

  get theme() {
    const { config: { occluri } } = store.getState();
    return occluri ? 'occl' : 'tefOne';
  }

  get userIsInRegisterFlow() {
    const { config: { registerToken, newcustomer } } = store.getState();
    //             LEGACY           RAITT
    return Boolean(registerToken || newcustomer);
  }

  get userIsInEditMode() {
    const { config: { mode }, consents } = store.getState();
    if (mode.includes('multiedit') && consents.editmodeActiveGroupInd === -1) {
      return false;
    }
    return true;
  }

  saveCustomerAttributeToStore(customerAttribute: CustomerAttribute): void {
    store.dispatch(setCustomerAttribute(customerAttribute));
  }

  getTemplateFnFor(templateName: string) {
    return this.getTemplateFn(templateName);
  }

  get mainComponentTag() {
    return 'tef-coms';
  }
}
